import React from 'react';
import PropTypes from 'prop-types';

import NutritionSettings from
'../../../../components/ClientInfo/components/ClientSettings/NutritionSettings/NutritionSettings';
import {
  StyledTableContainer,
  StyledTable,
  StyledTableHead,
  StyledTableRow,
  StyledHeaderCell,
} from '../styles';
import { ContentWrapper } from './styles';
import texts from './texts';

const NutritionSettingsWrapper = ({ clientId }) => (
  <StyledTableContainer>
    <StyledTable>
      <StyledTableHead>
        <StyledTableRow $header>
          <StyledHeaderCell $highlight>{texts.title}</StyledHeaderCell>
        </StyledTableRow>
      </StyledTableHead>
    </StyledTable>
    <ContentWrapper>
      <NutritionSettings clientId={clientId} />
    </ContentWrapper>
  </StyledTableContainer>
);

NutritionSettingsWrapper.propTypes = {
  clientId: PropTypes.string.isRequired,
};

export default NutritionSettingsWrapper;
